import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import authService from '../services/authService';
import logo from '../assets/images/logo-redonda.png';
import './Layout.css';

function Layout({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [manageMenuOpen, setManageMenuOpen] = useState(false);
  const user = authService.getCurrentUser();
  const dropdownRef = useRef(null);

  const handleLogout = async () => {
    try {
      await authService.logout();
      // Força a atualização completa da página para garantir limpeza do estado
      window.location.href = '/login';
    } catch (error) {
      console.error('Erro ao fazer logout:', error);
      // Mesmo com erro, limpa e redireciona
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
  };

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  const isManageMenuActive = () => {
    return ['/categories', '/accounts'].includes(location.pathname);
  };

  const handleManageMenuToggle = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setManageMenuOpen(!manageMenuOpen);
  };

  const handleManageMenuMouseEnter = () => {
    if (window.innerWidth > 768) {
      setManageMenuOpen(true);
    }
  };

  const handleManageMenuMouseLeave = () => {
    if (window.innerWidth > 768) {
      setManageMenuOpen(false);
    }
  };

  // Fechar dropdown ao clicar fora
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setManageMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="layout">
      <header className="header">
        <div className="header-content">
          <Link to="/dashboard" className="header-left logo-link" title="Ir para Dashboard">
            <img src={logo} alt="Finanças 360" className="logo-image" />
            <h1 className="logo">Finanças 360</h1>
          </Link>
          <nav className={`nav ${menuOpen ? 'open' : ''}`}>
            <Link to="/transactions" className={`nav-link ${isActive('/transactions')}`}>
              Transações
            </Link>
            <Link to="/virtual-transactions" className={`nav-link ${isActive('/virtual-transactions')}`}>
              Transações Fixas
            </Link>
            <div 
              ref={dropdownRef}
              className={`nav-dropdown ${isManageMenuActive() ? 'active' : ''}`}
              onMouseEnter={handleManageMenuMouseEnter}
              onMouseLeave={handleManageMenuMouseLeave}
            >
              <button 
                className={`nav-link dropdown-toggle ${isManageMenuActive() ? 'active' : ''}`}
                onClick={handleManageMenuToggle}
              >
                Gerenciar ▾
              </button>
              <div className={`dropdown-menu ${manageMenuOpen ? 'show' : ''}`}>
                <Link 
                  to="/categories" 
                  className={`dropdown-item ${isActive('/categories')}`}
                >
                  Categorias
                </Link>
                <Link 
                  to="/accounts" 
                  className={`dropdown-item ${isActive('/accounts')}`}
                >
                  Contas
                </Link>
              </div>
            </div>
            <Link to="/reports" className={`nav-link ${isActive('/reports')}`}>
              Relatórios
            </Link>
          </nav>
          <div className="header-right">
            <Link to="/profile" className="user-name">
              {user?.name}
            </Link>
            <button onClick={handleLogout} className="logout-button">
              Sair
            </button>
          </div>
          <button 
            className="menu-toggle" 
            onClick={() => setMenuOpen(!menuOpen)}
          >
            ☰
          </button>
        </div>
      </header>
      <main className="main-content">{children}</main>
    </div>
  );
}

export default Layout;
